import React, { useState, useRef, CSSProperties } from "react"
import { get, find, findKey } from "lodash"
import ClassNames from "classnames"
import AwaitableDom from "components/atoms/input/awaitableDom"

type Option = {
  id: number | string
  name: string
  disabled?: boolean
  cls?: string
  icon?: string
}

type Props = {
  option: Array<Option>
  onChange?: Function
  value?: string | number | undefined
  defaltValueId?: number
}

// export const BaseSelect: React.FC<Props> = props => {
//   const [selecting, changeSelectStatus] = useState(false)
//   const [isProcessingStat, setIsProcessingStat] = useState(false)
//   const [isHover, changeHover] = useState(0)
//   const currentCheck = find(props.option, {
//     id: props.value || props.defaltValueId || 0,
//   })
//   const currentCheckNum = findKey(props.option, {
//     id: props.value || props.defaltValueId || 0,
//   })

//   //liごとにonClickがあるのでawaitableDomだけじゃなくてここも管理する必要がある。
//   const isProcessing = useRef(false)

//   const notAllowStyle: CSSProperties = isProcessingStat
//     ? { opacity: 0.5, cursor: "progress" }
//     : undefined

//   return (
//     <div className="select-control filter-control-item">
//       <ul
//         style={notAllowStyle}
//         className={ClassNames("select", {
//           "is-open": selecting,
//         })}
//         tabIndex={0}
//         onBlur={() => {
//           changeSelectStatus(false)
//           props.onBlur && props.onBlur(false)
//         }}
//         onClick={() => {
//           if (isProcessing.current) return
//           changeSelectStatus(!selecting)
//           changeHover(Number(currentCheckNum))
//           props.onClick && props.onClick(!props.isSelect)
//         }}
//       >
//         <li className={ClassNames(get(currentCheck, "cls"))}>
//           <span className="select-list-items">
//             {get(currentCheck, "icon") ? (
//               <i className={ClassNames(currentCheck.icon)} />
//             ) : null}
//             {get(currentCheck, "name", "")}
//             <i className="material-icons">arrow_drop_down</i>
//           </span>
//         </li>
//         {props.option.map((row, i) => (
//           <AwaitableDom
//             key={i}
//             value={row.id}
//             className={ClassNames(row.cls, {
//               hover: isHover === i,
//               disabled: row.disabled,
//             })}
//             onClick={async () => {
//               if (isProcessing.current) return
//               isProcessing.current = true
//               setIsProcessingStat(true)
//               !row.disabled && props.onChange && (await props.onChange(row.id))
//               isProcessing.current = false
//               setIsProcessingStat(false)
//             }}
//             onMouseEnter={() => changeHover(i)}
//             onMouseLeave={() => changeHover(Number(currentCheckNum))}
//             onMouseMove={() => isHover !== i && changeHover(i)}
//             style={{ display: selecting ? "block" : "none" }}
//           >
//             <li>
//               <span className="select-list-items">
//                 {row.icon ? <i className={ClassNames(row.icon)} /> : null}
//                 {row.name}
//               </span>
//             </li>
//           </AwaitableDom>
//         ))}
//       </ul>
//     </div>
//   )
// }

export const BaseSelect: React.FC<Props> = props => {
  const [selecting, changeSelectStatus] = useState(false)
  const [isHover, changeHover] = useState(0)
  const [temporarilyHidden, setTemporarilyHidden] = useState(false)
  const currentCheck = find(props.option, {
    id: props.value || props.defaltValueId || 0,
  })
  const currentCheckNum = findKey(props.option, {
    id: props.value || props.defaltValueId || 0,
  })

  return (
    <>
      {selecting && (
        <div
          className={ClassNames("disable-trigger", {
            hidden: temporarilyHidden,
          })}
          onClick={() => {
            changeSelectStatus(false)
          }}
          onWheel={() => {
            //画面のスクロールが効かないので一瞬このdivを消す。
            setTemporarilyHidden(true)
            setTimeout(() => {
              setTemporarilyHidden(false)
            }, 100)
          }}
        />
      )}
      <div
        className={ClassNames("select-control", {
          active: selecting,
        })}
      >
        <div
          className={ClassNames("selected-items", get(currentCheck, "cls"))}
          onClick={() => {
            changeSelectStatus(!selecting)
            changeHover(Number(currentCheckNum))
          }}
        >
          <div className="selected-title-group">
            {get(currentCheck, "icon") ? (
              <i className={ClassNames(currentCheck.icon)} />
            ) : null}
            <span className="select-list-items-title">
              {get(currentCheck, "name", "")}
            </span>
          </div>
          <i className="material-icons arrow_drop_down">arrow_drop_down</i>
        </div>
        {selecting && (
          <div
            className={ClassNames("select", {
              "is-open": selecting,
            })}
            tabIndex={0}
            onMouseLeave={() => changeHover(null)}
          >
            {props.option.map((row, i) => (
              <div
                key={i}
                className={ClassNames("select-list-items-wrapper", row.cls, {
                  hover: isHover === i,
                  disabled: row.disabled,
                })}
                onClick={() => {
                  props.onChange && props.onChange(row.id)
                  changeSelectStatus(false)
                }}
                onMouseMove={() => isHover !== i && changeHover(i)}
                onMouseEnter={() => changeHover(i)}
              >
                <div className="select-list-items">
                  {row.icon ? <i className={ClassNames(row.icon)} /> : null}
                  <span>{row.name}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  )
}
